{
  "settings": "設定",
  "yourDigitalAssistant": "デジタルアシスタント",
  "getStarted": "スタート",
  "login": "ログイン",
  "loggingIn": "ログインしています...",
  "darkMode": "明るさ",
  "clearHistory": "履歴を削除する",
  "historyCleared": "履歴を削除しました",
  "changeLanguage": "言語",
  "termsAndConditions": "利用規約",
  "messagePlaceholder": "ここにメッセージを入力してください...",
  "messagePlaceholderDisabled": "入力を無効にしています...",
  "feedbackTitle": "星の数で評価してください",
  "feedbackPlaceholder": "具体的な評価内容を入力してください（任意）",
  "feedbackSend": "送信",
  "feedbackClose": "閉じる",
  "sessionExpired": "タイムアウトしました",
  "startNewSession": "再スタート",
  "apiError": "エラーが発生しました。現在、修復中です",
  "apiErrorOffline": "インターネットに接続されていません",
  "tryAgain": "再試行",
  "startOver": "はじめからやり直す",
  "chatEnded": "チャットは終了しました。",
  "chatEndedThankYou": "お話ありがとうございます！",
  "closeChat": "閉じる",
  "startNewChat": "もう一度チャット",
  "humanTakeoverStarted": "カスタマーサービスに転送中です",
  "humanTakeoverQueued": "カスタマーサービスの担当者に接続中です",
  "humanTakeoverAnAgent": "カスタマーサービスの担当者",
  "humanTakeoverAgentEntered": "カスタマーサービスのチャットにお繋ぎしました",
  "humanTakeoverAgentLogout": "カスタマーサービスとのチャットを終了しました",
  "humanTakeoverTransfer": "別の担当者に転送中です",
  "humanTakeoverEnded": "デジタルアシスタントのチャットに戻りました",
  "version": "バージョン",
  "formIntroText": "チャットを開始します。最初に以下の項目を入力してください",
  "formFirstName": "名",
  "formLastName": "姓",
  "formName": "名前",
  "formEmail": "メールアドレス",
  "formWrongEmail": "有効なメールアドレスを入力してください",
  "formPhone": "電話番号",
  "formShipmentId": "運送状番号",
  "formQuestion": "問い合わせ内容",
  "formAccountNumber": "口座番号（法人の場合）",
  "formAddress": "住所",
  "formPostcode": "郵便番号",
  "formCity": "市",
  "formCountry": "国",
  "formSubmitButton": "チャットを開始する",
  "formEmptyFieldError": "必須項目が入力されていません",
  "formPhoneNumberValidationError": "正しい電話番号を入力してください",
  "formInputIsBiggerThan50": "50文字以内で入力してください",
  "formInputIsBiggerThan100": "100文字以内で入力してください",
  "formInputIsBiggerThan2000": "2000文字以内で入力してください",
  "widgetEventOnline": "DAメッセージ：ユーザーがオンラインに戻りました。",
  "widgetEventHidden": "DAメッセージ：ウィジェットは非表示です。",
  "widgetEventVisible": "DAメッセージ：ウィジェットが表示されます。",
  "widgetEventVisibleMinimized": "DAメッセージ：ウィジェットは表示されますが、最小化されています。",
  "widgetEventMinimized": "DAメッセージ：ウィジェットは最小化されています。",
  "widgetEventMaximized": "DAメッセージ：ウィジェットは最大化されています。",
  "widgetEventSessionExpired": "DAメッセージ：ウィジェットセッションが期限切れです。",
  "widgetEventHangupHuman": "DAメッセージ：ユーザーがヒューマンテイクオーバーセッションを終了します。",
  "widgetEventUserTyping": "DAメッセージ：ユーザーが入力しています。",
  "fileTooLarge": "大きすぎるファイルを添付しようとしています。",
  "tooManyDiles": "あまりにも多くのファイルを添付しようとしています。",
  "fileInvalidType": "無効なファイルタイプを添付しようとしています。",
  "attachmentsDropHere": "ここにドロップしてアップロードするか、",
  "attachmentsBrowse": "ブラウズファイル",
  "attachmentsExtenstionQuantity": "PDFまたは画像（最大10ファイル）",
  "attachmentsSize": "最大30MB",
  "attachmentsFailedUploading": "アップロードに失敗しました",
  "attachmentsUploading": "アップロード中...",
  "minimizeExpandText": "今すぐライブチャット！",
  "popupWidgetNotificationMessage": "新しいメッセージが届きました！",
  "tabWidgetNotificationMessage": "新しいメッセージ！",
  "datepickerSendButton": "送信済"
}
